export default "__VITE_ASSET__DR0ZYBT5__"